import { Component, createRef } from "preact"
import Badge from "./personalized/badge"
import { widgetV2Url } from "../constants"
import CopyButton from "./personalized/copy-button"
import { __ } from "../../locales"

class IframePreview extends Component {
  constructor(props) {
    super(props)
    this.codeRef = createRef()
  }

  componentDidMount() {
    this.initScript()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.template !== this.props.template) {
      this.cleanScript()
      this.initScript()
    }
  }

  componentWillUnmount() {
    this.cleanScript()
  }

  cleanScript() {
    const iframeScript = document.querySelector(`#${this.props.widgetName}`)
    if (iframeScript) {
      window.onmessage = () => {}
      iframeScript.remove()
    }
  }

  initScript() {
    if (!this.props.template) {
      return
    }
    const iframeScript = document.querySelector(`#${this.props.widgetName}`)
    if (!iframeScript) {
      const script = document.createElement("script")
      script.setAttribute("id", this.props.widgetName)
      script.setAttribute("type", "text/javascript")
      script.setAttribute(
        "src",
        `${widgetV2Url}/doctify-widget-autoresize-plugin.js?tenantId=athena-uk&widgetName=${this.props.widgetName}&containerId=${this.props.id}`
      )
      document.head.appendChild(script)
    }
  }

  render({ fixedWidth, fixedHeight, defaultHeight, template, shouldLoad }) {
    if (!template || !shouldLoad) {
      return <div style={{ height: defaultHeight }} />
    }
    return (
      <>
        <div className="code-snippet">
          <div className={"preview mb-5"}>
            <div
              className={"d-flex justify-content-between"}
              style={{ gap: "15px" }}
            >
              <p>{__("global.preview")}</p>
              <Badge
                text={this.props.badgeTitle}
                fontColor={this.props.badgeFontColor}
                bgColor={this.props.badgeColor}
                smaller
              />
            </div>
            <div
              className={"container d-flex align-items-center flex-column"}
              dangerouslySetInnerHTML={{ __html: template }}
              style={{
                ...(fixedWidth ? { width: fixedWidth } : {}),
                ...(fixedHeight ? { height: fixedHeight } : {}),
              }}
            />
          </div>
          <p className={"code-snippet-title mb-3"}>
            {__("copy_code_disclaimer")}
          </p>
          <div className="pre-code">
            <CopyButton textRef={this.codeRef} />
            <code ref={this.codeRef}>{template}</code>
          </div>
        </div>
      </>
    )
  }
}

export default IframePreview
